import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6cng0pthbr: FaireBrandEntity = {
  token: "b_6cng0pthbr",
  type: "brand",
  name: "Manic Panic",
  avatarUrl:
    "https://cdn.faire.com/fastly/b45f617dc14901e7ed8220ef57aaed2c10ac130d13b7fbfeabe0587e3df258ae.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c2accd1bf4cbdfafdc2b9a7479ad7563db88cd521a16122b9d401608f05efde7.png",
  logoUrl:
    "https://cdn.faire.com/fastly/b45f617dc14901e7ed8220ef57aaed2c10ac130d13b7fbfeabe0587e3df258ae.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c2accd1bf4cbdfafdc2b9a7479ad7563db88cd521a16122b9d401608f05efde7.png",
  location: "New York City, NY, USA",
  minimumOrderDollars: 150,
  rating: 4.7,
  reviewCount: 23,
  isInsider: true,
  description:
    "Manic Panic is a trailblazing, women-owned and Latina-owned hair color brand founded by sisters Tish and Snooky nearly five decades ago. We helped spark the vivid hair color revolution and continue to stand as a global icon of creative self expression and alternative beauty culture.\n\nWe are a multi-generational, culture driven brand with Gen Z and Millennials as our core consumers, while inspiring loyal fans across every age group.\n\nAt Manic Panic, self expression goes beyond hair color. Through Color With A Conscience™ and our Dye For Peace™ Program, we donate 15% of profits to support social justice, health initiatives, animal welfare, and humanitarian causes worldwide. Bold creativity and meaningful impact go hand in hand.\n\nWe create products for artists, trend leaders, and expressive consumers who see color as identity, attitude, and art, not just beauty.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:38.820Z",
    importedBy: "entity-db-cli",
  },
};
